exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table-app{display:block}table-app .table-responsive{border:0}table-app .table{width:auto;table-layout:fixed;margin-bottom:10px}table-app .table thead tr th{color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;border-bottom:2px solid #dddfe2;border-right:2px solid #dddfe2;padding:0 15px 10px;text-align:center;white-space:nowrap;text-transform:uppercase}table-app .table thead tr th .icon.icon-interrogation-color{display:inline-block;margin-left:6px;font-size:19px;vertical-align:middle;margin-bottom:4px;font-weight:400}table-app .table thead tr th:first-of-type{text-align:left;padding-left:0}table-app .table tbody tr:last-of-type td{padding-bottom:25px}table-app .table tbody tr td{color:#666;font-family:Stag Sans;font-size:15px;font-weight:400;border-right:2px solid #dddfe2;border-top:0;padding:27px 25px 0 0;text-align:right;white-space:nowrap}table-app .table tbody tr td:first-of-type{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/table/table.scss
// module id = 747
// module chunks = 0